const INIT_PROVIMCE= 'initProvimce'
const INIT_CITY= 'initCity'
const GET_APPLY_DETAIL = "getApplyDrugDetail"
const ACTIVITY_FORM_LINE = 'activityFormLine'
export default {
    INIT_CITY,
    INIT_PROVIMCE,
    GET_APPLY_DETAIL,
    ACTIVITY_FORM_LINE
}



// WEBPACK FOOTER //
// ./src/store/modules/base/types.js